import React from "react"
import Rating from "./Rating"

const ReviewsListItem = ({ review }) => (
  <div className="ReviewsListItem">
    <div className="ReviewsListItem-side">
      <div className="ReviewsListItem-rating">
        <Rating value={review.rating} />
      </div>
    </div>
    <div className="ReviewsListItem-main">
      <div className="ReviewsListItem-headers">
        {review.product_name && (
          <div className="ReviewsListItem-title">
            {review.product_url
              ? <a href={review.product_url} target="_blank">{review.product_name}</a>
              : review.product_name
            }
          </div>
        )}
      </div>
      <div className="ReviewsListItem-content">{review.content}</div>
      <div className="ReviewsListItem-metas">
        <span className="ReviewsListItem-meta">
          <strong>{review.author_name || I18n.humanAttributeName("review", "anonymous")}</strong>, {moment(review.created_at).fromNow()}
        </span>
        {review.verified && (
          <strong className="ReviewsListItem-meta">{I18n.humanAttributeName("review", "verified")}</strong>
        )}
        {review.age_group && (
          <span className="ReviewsListItem-meta">{review.age_group}</span>
        )}
        {review.group_type && (
          <span className="ReviewsListItem-meta">{review.group_type}</span>
        )}
      </div>
    </div>
  </div>
)

export default ReviewsListItem


// WEBPACK FOOTER //
// ./app/webpack/frontend/features/ReviewsListWidget/ReviewListItem.jsx